import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { CloseTemplateBasis } from "@common/schemas/close-template.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { memo } from "react";
import { CloseTemplateRow } from "../organizationCloseTemplatesViewConfig";

const basisLabels: Record<CloseTemplateBasis, string> = {
    [CloseTemplateBasis.ACCRUAL]: "Accrual",
    [CloseTemplateBasis.MODIFIED_CASH_LEDGER]: "Cash",
};

export const CloseTemplateBasisCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CloseTemplateRow, unknown>) => {
        const { basis } = row.original;

        return (
            <ViewTableCell>
                <span className="text-secondary">
                    {basis ? basisLabels[basis] : "-"}
                </span>
            </ViewTableCell>
        );
    },
);
